module.exports = __webpack_public_path__ + "ed11f7f850e648f43f41b6ea2bacdee2.otf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/MyriadPro-BoldIt.otf
// module id = 246
// module chunks = 0